import React, { useEffect, useState } from "react";
import styles from "../TriggerField.module.scss";
import { TextField } from "@mui/material";
import { CustomDropdown } from "components/shared/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems } from "redux/slices/triggerSlice";
import { setPublish } from "redux/slices/globalSlice";

const optionsArray = [
    { label: "is", value: "is" },
    { label: "is not", value: "is not" },
    { label: "greater than", value: "greater than" },
    { label: "greater than or equal", value: "greater than or equal" },
    { label: "less than", value: "less than" },
    { label: "less than or equal", value: "less than or equal" },
    { label: "is between", value: "is between" },
    { label: "is not between", value: "is not between" },
    { label: "is answered", value: "is answered" },
    { label: "is unanswered", value: "is unanswered" },

];
const Number = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Number", options: item?.operator || "is", value: item?.value || [], number1: item?.value?.[0], number2: item?.value?.[1] });

    const dispatch = useDispatch();

    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };


            if (name === "options") {
                if (value === "is between" || value === "is not between") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                        number1: "",
                        number2: "",
                    };
                } else if (value === "is answered" || value === "is unanswered") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                        number1: "",
                        number2: "",
                    };
                } else {
                    updatedOptions = {
                        ...updatedOptions,
                        number1: "",
                        number2: "",
                    };
                }
            }

            return updatedOptions;
        });
    };

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Number", 
                    trigger: {
                        ...localOptions,
                        // ...(localOptions?.options == "is answered" || localOptions?.options == "is unanswered" ? {}: null)
                    },
                };
            }
            return e;
        });


        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);
    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            ...(item?.value?.[0] ? {
                number1: item?.value?.[0]
            } : {}),
            ...(item?.value?.[1] ? {
                number2: item?.value?.[1]
            } : {}),
            ...(item?.value ? {
                value: item?.value
            } : {}),
        }));
    }, [item?.operator, item?.value]);

    //     useEffect(() => {
    // if(item?.operator === "is between"){
    //     setLocalOptions((prev) => ({
    //         ...prev,
    //         options: item?.operator || prev.options,
    //         value : Array.isArray(item?.value) ? [...item.value] : prev.value
    //     }));
    // }else {

    //       setLocalOptions((prev) => ({
    //             ...prev,
    //             options: item?.operator || prev.options,
    //             value: item?.value || prev.value
    //         }));
    //     }
    //     }, [item?.operator,JSON.stringify(item?.value)]);

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={item?.label || "Number"} disabled name="label" />

                <CustomDropdown
                    width='200px'
                    name="options"
                    options={optionsArray}
                    value={localOptions?.options || ""}
                    onChange={(e) => {
                        handleChange(e?.target?.name, e?.target?.value)
                    }}
                />
                {
                    localOptions?.options == "is between" || localOptions?.options == "is not between" ?

                        <>
                            <div style={{
                                display: "flex", alignItems: "center", gap: "10px"
                            }}>
                                <TextField
                                    name="number1"
                                    value={localOptions?.number1 || ""}
                                    onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                                />
                                <span style={{ fontWeight: "700", fontSize: "15px" }}>And</span>
                                <TextField
                                    name="number2"
                                    value={localOptions?.number2 || ""}
                                    onChange={(e) => {
                                        handleChange(e?.target?.name, e?.target?.value)
                                    }}
                                />
                            </div>
                        </>
                        :
                        localOptions?.options == "is answered" || localOptions?.options == "is unanswered" ? null :
                            <TextField
                                name="value"
                                value={localOptions?.value || ""}
                                onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                            />

                }
            </div>


            <div
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default Number;
